module.exports = __webpack_public_path__ + "static/img/ninja-can-18.6b668335.png";